import { render } from "./add-to-template.vue?vue&type=template&id=248479ca&lang=pug"
import script from "./add-to-template.vue?vue&type=script&lang=js"
export * from "./add-to-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__